export const faqData = [
  {
    id: 1,
    question: " What is a Gold Loan EMI Calculator?",
    answer:
      "A Gold Loan EMI Calculator is a tool that helps you calculate your monthly repayment amount based on the loan amount, tenure, and interest rate.",
  },

  {
    id: 2,
    question: "How accurate is the EMI calculation?",
    answer:
      "The EMI calculation is highly accurate and uses a standard formula applicable across lenders.",
  },

  {
    id: 3,
    question: "Can I adjust the tenure and interest rate?",
    answer:
      "Yes, you can customize the loan tenure and interest rate to see different EMI results.",
  },
  {
    id: 4,
    question: "Is the Gold Loan EMI Calculator free?",
    answer: "Yes, Minemi’s Gold Loan EMI Calculator is completely free to use.",
  },
];
